import React from "react";
import "../css/register.css";
import Login from "./Login";
import { useAuth } from "./auth";

const Home = () => {
  const { user } = useAuth();

  return (
    <div>
      <div className="welcome-msg">Welcome @ {user}</div>
      <div className="header container-box">Home page</div>
      <div className="HomeContainer">
        <div className="container-box">
          <div className="login-container">
            <div>{user ? null : <Login />}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
